import { ForgotPassword } from '@/features/auth';

const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;
